module.exports = {
      id: "setting-icon-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#setting-icon",
      toString: function () {
        return this.url;
      }
    }